module.exports = __webpack_public_path__ + "static/combat_icon-78f75a7ababce3e1da1c8fa6453021c3.png";